module.exports = __webpack_public_path__ + "img/学术会议-3.534e47d6.png";